import styled from 'styled-components';
import TextField from './TextField';
import Checkbox from './Checkbox';
import Select from './Select';
import ResourceSpace from './ResourceSpace';
import Groupbox from './Groupbox';
import MultipleSelect from './MultipleSelect';

const Form = styled.form``;

Form.TextField = TextField;
Form.Checkbox = Checkbox;
Form.Select = Select;
Form.ResourceSpace = ResourceSpace;
Form.Groupbox = Groupbox;
Form.MultipleSelect = MultipleSelect;

export default Form;
